import AppointmentSupport from './AppointmentSupport';

import './index.css';

export default AppointmentSupport;
